import { musiclinkAPI, fetchLogosAPI } from "./api"

export function fetchMusiclink(isrc) {
    return new Promise((resolve, reject) => {
        musiclinkAPI(isrc).then(res => resolve(res)).catch(err => reject(err))
    })
}

export function fetchLogos() {
    return fetchLogosAPI();
}
